import { render, staticRenderFns } from "./CScrollTable.vue?vue&type=template&id=9df18880&scoped=true"
import script from "./CScrollTable.vue?vue&type=script&lang=js"
export * from "./CScrollTable.vue?vue&type=script&lang=js"
import style0 from "./CScrollTable.vue?vue&type=style&index=0&id=9df18880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df18880",
  null
  
)

export default component.exports